{
  "familyId": "SPR-LEEN-C-S-K",
  "questions": [
    {
      "id": "SPR-LEEN-C-S-K-001",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een taalleraar vraagt: in welk woord klinkt de C als een S?",
      "options": ["circus", "cola", "computer", "cake"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S of K", "content": "De letter C klinkt als S vóór e en i: circus, cent, citroen. De C klinkt als K vóór a, o en u: cola, computer, cake.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_s",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De taalleraar legt uit: de C klinkt als S vóór de letters e en i. In 'circus' staat de C vóór een i, dus klinkt het als S. Bij cola, computer en cake staat de C vóór a, o of u, dus klinkt het als K.",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "C + i of e → S-klank",
          "C + a, o of u → K-klank",
          "Circus: C + i → S-klank ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! C + i = S-klank: circus.",
          "1": "Je dacht waarschijnlijk dat cola een S-klank heeft. Maar de C in 'cola' staat vóór een o → K-klank. Onthoud: C + a/o/u = K-klank.",
          "2": "Je dacht waarschijnlijk dat computer een S-klank heeft. Maar de C in 'computer' staat vóór een o → K-klank. Onthoud: C + a/o/u = K-klank.",
          "3": "Je dacht waarschijnlijk dat cake een S-klank heeft. Maar de C in 'cake' staat vóór een a → K-klank. Onthoud: C + a/o/u = K-klank."
        }
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-002",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft een artikel. Welk woord begint met een K-klank?",
      "options": ["cactus", "centrum", "citroen", "circus"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als K-klank", "content": "De C klinkt als K vóór a, o en u: cactus, cola, computer. Vóór e en i klinkt de C als S: centrum, circus.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_k",
      "variantIndex": 2,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De journalist weet: de C klinkt als K vóór de letters a, o en u. In 'cactus' staat de C vóór een a, dus klinkt het als K. Bij centrum, citroen en circus staat de C vóór e of i, dus klinkt het als S.",
        "solutionSteps": [
          "Kijk naar de letter ná de C",
          "C + a, o of u → K-klank",
          "C + i of e → S-klank",
          "Cactus: C + a → K-klank ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! C + a = K-klank: cactus.",
          "1": "Je dacht waarschijnlijk dat centrum een K-klank heeft. Maar de C in 'centrum' staat vóór een e → S-klank. Onthoud: C + e/i = S-klank.",
          "2": "Je dacht waarschijnlijk dat citroen een K-klank heeft. Maar de C in 'citroen' staat vóór een i → S-klank. Onthoud: C + e/i = S-klank.",
          "3": "Je dacht waarschijnlijk dat circus een K-klank heeft. Maar de C in 'circus' staat vóór een i → S-klank. Onthoud: C + e/i = S-klank."
        }
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-003",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een corrector controleert: welk woord heeft een S-klank bij de C?",
      "options": ["cent", "cadeau", "cursus", "camping"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C als S-klank", "content": "De C klinkt als S vóór e en i. 'Cent' begint met C + e → S-klank. De andere woorden hebben C + a of u → K-klank.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_s_advanced",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De corrector weet: de C klinkt als S vóór e en i. In 'cent' staat de C vóór een e → S-klank. Bij cadeau (C + a), cursus (C + u) en camping (C + a) klinkt de C als K.",
        "solutionSteps": [
          "Bekijk elk woord: welke letter staat ná de C?",
          "Cent: C + e → S-klank ✓",
          "Cadeau: C + a → K-klank",
          "Cursus: C + u → K-klank",
          "Camping: C + a → K-klank"
        ],
        "distractorExplanations": {
          "0": "Goed! C + e = S-klank: cent.",
          "1": "Je dacht waarschijnlijk dat cadeau een S-klank heeft. Maar de C in 'cadeau' staat vóór een a → K-klank. Onthoud: C + a = K-klank.",
          "2": "Je dacht waarschijnlijk dat cursus een S-klank heeft. Maar de C in 'cursus' staat vóór een u → K-klank. Onthoud: C + u = K-klank.",
          "3": "Je dacht waarschijnlijk dat camping een S-klank heeft. Maar de C in 'camping' staat vóór een a → K-klank. Onthoud: C + a = K-klank."
        }
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-004",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een vertaler vertaalt: waarom schrijven we 'concert' met een C en niet met een K of S?",
      "options": [
        "Omdat 'concert' een leenwoord is — we houden de originele spelling",
        "Omdat de C altijd als K klinkt",
        "Omdat de C altijd als S klinkt",
        "Omdat het een Nederlands woord is"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Leenwoorden met C", "content": "Woorden als 'concert', 'circus' en 'cactus' komen uit andere talen (Latijn, Frans). We houden de originele spelling met C, ook al klinkt het als K of S.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_loanword_origin",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De vertaler weet: 'concert' is een leenwoord uit het Frans/Latijn. We houden de originele spelling met C, ook al klinkt het als K of S. Daarom schrijven we 'concert' en niet 'konsert'.",
        "solutionSteps": [
          "'Concert' komt uit het Frans/Latijn",
          "Leenwoorden houden hun originele spelling",
          "Daarom schrijven we C, niet K of S",
          "Andere voorbeelden: circus, cactus, café"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Concert' is een leenwoord — we houden de originele spelling met C.",
          "1": "Je dacht waarschijnlijk dat de C altijd als K klinkt. Maar in 'concert' klinkt de eerste C als K (C + o) en de tweede als S (C + e). De C heeft twee klanken. Onthoud: C + a/o/u = K, C + e/i = S.",
          "2": "Je dacht waarschijnlijk dat de C altijd als S klinkt. Maar in 'cactus' klinkt de C als K (C + a). De C heeft twee klanken. Onthoud: C + a/o/u = K, C + e/i = S.",
          "3": "Je dacht waarschijnlijk dat 'concert' een Nederlands woord is. Maar het komt uit het Frans/Latijn. Nederlandse woorden gebruiken K of S, leenwoorden houden de C. Onthoud: C = leenwoord."
        }
      }
    },
    {
      "id": "SPR-LEEN-C-S-K-005",
      "familyId": "SPR-LEEN-C-S-K",
      "module": "SpellingRegel",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "leenwoorden",
      "subSkill": "leen_c_uitspraak",
      "questionType": "multiple_choice",
      "question": "Een redacteur vraagt: in het woord 'december' — klinkt de C als S of als K?",
      "options": ["Als S (want C + e)", "Als K (want C + e)", "Als S (want C + a)", "Je hoort de C niet"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "C in december", "content": "In 'december' staat de C vóór een e. C + e = S-klank. Zeg het hardop: de-SEM-ber. Je hoort duidelijk een S-klank.", "icon": "lightbulb" } }
      ],
      "conceptId": "c_pronunciation_in_context",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De redacteur weet: in 'december' staat de C vóór een e. C + e = S-klank. Zeg het hardop: de-SEM-ber. Je hoort duidelijk een S-klank.",
        "solutionSteps": [
          "Zoek de C in 'december': de-C-ember",
          "Welke letter staat ná de C? → e",
          "C + e = S-klank",
          "December klinkt als de-SEM-ber ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! C + e = S-klank: december klinkt als de-SEM-ber.",
          "1": "Je dacht waarschijnlijk dat C + e een K-klank geeft. Maar C + e = S-klank, niet K-klank. Onthoud: C + e/i = S-klank.",
          "2": "Je dacht waarschijnlijk dat de C vóór een a staat. Maar in 'december' staat de C vóór een e: de-C-ember. Onthoud: kijk goed naar de letter ná de C.",
          "3": "Je dacht waarschijnlijk dat je de C niet hoort. Maar in 'december' hoor je de C duidelijk als S: de-SEM-ber. Onthoud: de C klinkt altijd, als S of als K."
        }
      }
    }
  ]
}